export const GET_REASON_BEGIN = "GET_REASON_BEGIN"
export const GET_REASON_SUCCESS = "GET_REASON_SUCCESS"